import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsReferenceSection = ({ section }) => <DocsLinksSection icon='globe' section={section} />;

export { DocsReferenceSection };
